import React from "react";

const addCurrencyMask = (e) => {
  let value = e.target.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d)(\d{2})$/, "$1,$2");
  value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
  e.target.value = value;
  return e;
};

const parseAmount = (amount) => {
  if (amount) {
    amount = amount.replace(/\./g, "");
    amount = amount.replace(/,/g, ".");
    return parseFloat(amount);
  }

  return 0;
};

const isCandidatureOptionChecked = (ids, id) => {
  return ids?.includes(parseInt(id));
};

const updateCheckedOptions = (items, id, checked) => {
  if (checked) {
    if (!items.includes(parseInt(id))) {
      items.push(parseInt(id));
    }
  } else {
    for (var i = 0; i < items.length; i++) {
      if (items[i] === parseInt(id)) {
        items.splice(i, 1);
      }
    }
  }

  return items;
};

const checkHasOwnBusiness = (occupations, id) => {
  return occupations && occupations.includes(id);
};

const checkIsEmployed = (occupations, ids) => {
  return occupations && occupations.some((id) => ids.includes(id));
};

// Transform form data for sending to backend
const transformCheckboxArraysToBooleans = (data) => {
  const transformedData = { ...data };

  // List of checkbox fields that should be converted from arrays to booleans
  const checkboxFields = [
    "isManufacturerOrProducer",
    "isServiceProvider",
    "isRetailer",
    "isWholesaler",
    "formalizationOfFamilyBusiness",
    "unemployment",
    "marketOpportunity",
    "incomeDiversification",
    "hasPermitOrLicenses",
    "hasEnvironmentalLicense",
    "isCategoryCActivity",
    "doesInvolveTheUseOfLand",
    "hasSomeFormalLandTitle",
    "isTitleValid",
    "doesInvolveRehabilitationOronstruction",
    "hasValidLicence",
  ];

  // Handle contract type fields as booleans
  if (transformedData.workers) {
    if (
      transformedData.workers.formalContract === false ||
      transformedData.workers.formalContract === ""
    ) {
      transformedData.workers.formalContract = null;
    }
    if (
      transformedData.workers.oralContract === false ||
      transformedData.workers.oralContract === ""
    ) {
      transformedData.workers.oralContract = null;
    }
  }

  // Handle empty string fields that should be null
  const stringFields = [
    "totalCollaborators",
    "currentMalesAged18To35",
    "currentFemalesAged18To35",
    "currentMalesAbove35",
    "currentFemalesAbove35",
    "males2025",
    "males2026",
    "males2027",
    "males2025Aged18To35",
    "males2026Aged18To35",
    "males2027Aged18To35",
    "females2025",
    "females2026",
    "females2027",
    "females2025Aged18To35",
    "females2026Aged18To35",
    "females2027Aged18To35",
  ];

  stringFields.forEach((field) => {
    if (transformedData[field] === "" || transformedData[field] === false) {
      transformedData[field] = null;
    }
  });

  checkboxFields.forEach((field) => {
    if (transformedData[field] && Array.isArray(transformedData[field])) {
      // Convert array to boolean: if array has "on" value, it's true, otherwise false
      transformedData[field] = transformedData[field].includes("on");
    } else if (transformedData[field] === false) {
      // Handle cases where checkbox fields are explicitly set to false
      transformedData[field] = false;
    }
  });

  // Handle financing purpose codes - convert checkbox arrays to Set<Integer>
  if (
    transformedData.financingPurposeCodes &&
    Array.isArray(transformedData.financingPurposeCodes)
  ) {
    const selectedCodes = [];
    const selectedDescs = [];

    // Map checkbox selections to codes and descriptions
    if (
      transformedData.financingPurposeCodes.includes("financingPurposeCode1")
    ) {
      selectedCodes.push(1);
      selectedDescs.push("para cobrir os custos operacionais previstos");
    }
    if (
      transformedData.financingPurposeCodes.includes("financingPurposeCode2")
    ) {
      selectedCodes.push(2);
      selectedDescs.push("Para financiar a expansão do negócio");
    }
    if (
      transformedData.financingPurposeCodes.includes("financingPurposeCode3")
    ) {
      selectedCodes.push(3);
      selectedDescs.push(
        "Para adicionar outro produto ou serviço à oferta actual"
      );
    }

    transformedData.financingPurposeCodes = selectedCodes;
    transformedData.financingPurposeDescs = selectedDescs;
  }

  return transformedData;
};

// Transform backend data for loading into forms
const transformBackendDataForForm = (backendData) => {
  if (!backendData) return {};

  const formData = { ...backendData };

  // Handle nested objects
  if (backendData.workers) {
    formData.workers = { ...backendData.workers };

    // Handle contract type fields for workers (boolean fields)
    if (backendData.workers.formalContract === true) {
      formData.workers.formalContract = true;
    } else {
      formData.workers.formalContract = false;
    }

    if (backendData.workers.oralContract === true) {
      formData.workers.oralContract = true;
    } else {
      formData.workers.oralContract = false;
    }
  }
  if (backendData.investmentPlan) {
    formData.investmentPlan = { ...backendData.investmentPlan };
  }
  if (backendData.provisionalPlan) {
    formData.provisionalPlan = { ...backendData.provisionalPlan };
  }
  if (backendData.salesPlan) {
    formData.salesPlan = { ...backendData.salesPlan };
  }

  // Handle financing purpose codes - convert from Set<Integer> to checkbox format
  if (
    backendData.financingPurposeCodes &&
    Array.isArray(backendData.financingPurposeCodes)
  ) {
    const checkboxValues = [];
    backendData.financingPurposeCodes.forEach((code) => {
      if (code === 1) checkboxValues.push("financingPurposeCode1");
      if (code === 2) checkboxValues.push("financingPurposeCode2");
      if (code === 3) checkboxValues.push("financingPurposeCode3");
    });
    formData.financingPurposeCodes = checkboxValues;
  }

  // Handle boolean fields for checkboxes
  const booleanFields = [
    "isManufacturerOrProducer",
    "isServiceProvider",
    "isRetailer",
    "isWholesaler",
    "formalizationOfFamilyBusiness",
    "unemployment",
    "marketOpportunity",
    "incomeDiversification",
    "hasPermitOrLicenses",
    "hasEnvironmentalLicense",
    "isCategoryCActivity",
    "doesInvolveTheUseOfLand",
    "hasSomeFormalLandTitle",
    "isTitleValid",
    "doesInvolveRehabilitationOronstruction",
    "hasValidLicence",
  ];

  booleanFields.forEach((field) => {
    if (formData[field] === true) {
      formData[field] = ["on"];
    } else if (formData[field] === false) {
      formData[field] = [];
    }
  });

  return formData;
};

// Transform dropdown values for backend
const transformDropdownValues = (data) => {
  const transformedData = { ...data };

  // Handle numeric dropdown fields
  const numericFields = [
    "provinceId",
    "districtId",
    "addressTypeCode",
    "legalFormOfBusinessCode",
    "ownerExperienceYears",
    "partner1ExperienceYears",
    "partner2ExperienceYears",
  ];

  numericFields.forEach((field) => {
    if (transformedData[field] && typeof transformedData[field] === "string") {
      const numValue = parseInt(transformedData[field]);
      if (!isNaN(numValue)) {
        transformedData[field] = numValue;
      }
    }
  });

  return transformedData;
};

export {
  updateCheckedOptions,
  checkHasOwnBusiness,
  checkIsEmployed,
  isCandidatureOptionChecked,
  addCurrencyMask,
  parseAmount,
  transformCheckboxArraysToBooleans,
  transformBackendDataForForm,
  transformDropdownValues,
};
